import { Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, ActivatedRoute} from '@angular/router';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { User } from '../../../../core/models/user/user';
import { StorageService } from '../../../../core/services/storage/storage.service';
import { UserService } from '../../../../core/services/user/user.service';

@Component({
    selector: 'app-parameters',
    templateUrl: './parameters.component.html',
    styleUrls: ['./parameters.component.scss'],
    imports: [RouterLink, NgClass, NgFor, NgIf, TranslateModule]
})
export class ParametersComponent  implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private translate = inject(TranslateService);
  private storageService = inject(StorageService);
  private userService = inject(UserService);


  parameterLinks: {
    path: string;
    name: string;
    icon: string;
    description: string;
  }[] = [];

  protected user: User | undefined;

  get isPremiumDiscoveryUser(): boolean { return this.userService.isPremiumDiscoveryUser(this.user); }
  get isPremiumGiftedUser(): boolean { return this.userService.isPremiumGiftedUser(this.user); }
  get isPremiumUser(): boolean { return this.userService.isPremiumUser(this.user); }
  get isProGiftedUser(): boolean { return this.userService.isProGiftedUser(this.user); }
  get isProUser(): boolean { return this.userService.isProUser(this.user); }
  get isEssentielGiftedUser(): boolean { return this.userService.isEssentielGiftedUser(this.user); }
  get isEssentielUser(): boolean { return this.userService.isEssentielUser(this.user); }
  get isStandardAutoImportUser(): boolean { return this.userService.isStandardAutoImportUser(this.user); }
  get isStandardUser(): boolean { return this.userService.isStandardUser(this.user); }

  ngOnInit() {
    this.user = this.storageService.getUser();
    this.loadTranslations();
    this.translate.onLangChange.subscribe(() => {
      this.loadTranslations();
    });
  }
  loadTranslations() {
    this.translate.get([
      'parameters.profil',
      'parameters.profilDesc',
      'parameters.accounts',
      'parameters.accountsDesc',
      'parameters.tags',
      'parameters.tagsDesc',
      'parameters.payees',
      'parameters.payeesDesc',
      'parameters.importPresentation',
      'parameters.importPresentationDesc',
      'parameters.import',
      'parameters.importDesc',
      'parameters.budgets',
      'parameters.budgetsDesc',
      'parameters.operations',
      'parameters.operationsDesc',
      'parameters.categories',
      'parameters.categoriesDesc'
    ]).subscribe(translations => {
      this.parameterLinks = [
        {
          path: 'account-info',
          name: translations['parameters.profil'],
          icon: 'bi-person-circle',
          description: translations['parameters.profilDesc']
        },
        {
          path: 'accounts',
          name: translations['parameters.accounts'],
          icon: 'bi-wallet',
          description: translations['parameters.accountsDesc']
        },
        {
          path: 'tags',
          name: translations['parameters.tags'],
          icon: 'bi-tag',
          description: translations['parameters.tagsDesc']
        },
        {
          path: 'payees',
          name: translations['parameters.payees'],
          icon: 'bi-people',
          description: translations['parameters.payeesDesc']
        },
        {
          path: 'import-presentation',
          name: translations['parameters.importPresentation'],
          icon: 'bi-file-earmark-arrow-up',
          description: translations['parameters.importPresentationDesc']
        },
        // {
        //   path: 'import',
        //   name: translations['parameters.import'],
        //   icon: 'bi-cloud-upload',
        //   description: translations['parameters.importDesc']
        // },
        {
          path: 'budgets',
          name: translations['parameters.budgets'],
          icon: 'bi-graph-up',
          description: translations['parameters.budgetsDesc']
        },
        // {
        //   path: 'operations',
        //   name: translations['parameters.operations'],
        //   icon: 'bi-list-check',
        //   description: translations['parameters.operationsDesc']
        // },
        {
          path: 'categories',
          name: translations['parameters.categories'],
          icon: 'bi-folder',
          description: translations['parameters.categoriesDesc']
        }
      ];
    });
  }
}
